import { twMerge } from "tailwind-merge";

export type SkeletonProps = {
  className?: string;
};

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={twMerge(
        "animate-pulse rounded-md bg-fg-disabled_subtle",
        className,
      )}
    />
  );
}
